<template>
  <div id="m0-check-list-rooms">
    <div class="rooms-area">
      <div
        class="room-item-container" 
        v-for="(room, index) in getRoomDatas" 
        :key="index" 
      >
        <div v-if="index > 0 && getRoomDatas[index -1].is_checked_weekly !== room.is_checked_weekly" class="category-separator"></div>
        <div
          class="room-item"
          :class="{
            'last-item':index === getRoomDatas.length-1,
            'first-item':index === 0,
            selected: room.room_id === getSelectedRoomId}"
        >
          <span class="room-text"
            :class="[
              room.isActive === false ? 'room-inactive' :
              room.room_id === getSelectedRoomId ? 'sdf-text-18-700-blue' : 'sdf-text-18-400-white' 
            ]"
            @click="roomClicked(room)"
            >{{room.room_name}}
          </span>
        </div>
      </div>
    </div>
    <div>
      <div v-if="this.getSelectedM0CheckListId && this.getSelectedM0CheckListId >= 0" class="print-button-area" @click="openPdfWindow">
        <feather-icon icon="PrinterIcon" svg-classes="h-5 w-5 stroke-current text-white" class="printer-icon" />
        <span class="sdf-text-18-400-white" :class="{ 'sdf-text-18-400-blue': isPdfBuilding }" >印刷用PDFファイル</span>
      </div>
    </div>
  </div>
</template>

<script>

import {createNamespacedHelpers} from "vuex"
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin"
const { mapGetters, mapActions } = createNamespacedHelpers("m0CheckListReport")

export default {
  name: "M0CheckListRooms",
  mixins: [SecureDataflowMixin],
  data() {
    return {
      isPdfBuilding: false,
      pdfWindow: null,
    }
  },
  computed: {
    ...mapGetters(["getSelectedM0CheckListId", "getSelectedRoomId", "getRoomDatas"]),
  },
  methods: {
    ...mapActions(["setSelectedRoomId", "getM0CheckListForPdf"]),
    roomClicked: function(room) {
      if ( room.isActive === true ) {
        this.setSelectedRoomId( room.room_id );
      }
    },
    /**
     * M0チェックリスト印刷用PDFファイルのソースを取得.
     * 
     */
    async openPdfWindow() {
      if ( !this.getSelectedM0CheckListId || this.getSelectedM0CheckListId < 0 ) {
        return;
      }
      this.isPdfBuilding = true;
      const htmlSource = await this.getM0CheckListForPdf(this.getSelectedM0CheckListId);
      this.pdfWindow = window.open('', "_blank");
      this.pdfWindow.document.open();
      this.pdfWindow.document.write(htmlSource);
      this.pdfWindow.document.close();
      this.isPdfBuilding = false;

    },
  },
  beforeDestroy() {
    if ( this.pdfWindow ) {
      this.pdfWindow.close();
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/secure-dataflow/_variables.scss";

#m0-check-list-rooms {
  background-color: $sdf-blue-gray;
  padding-left: 30px;
  color: $sdf-white;
  display: flex;
  align-items: center;

  .rooms-area {
    display: flex;
    overflow-x: auto;
    scrollbar-color: $sdf-gray $sdf-blue-gray;
    width: 100%;
    height: 74px;
    align-items: start;
  }

  .room-item-container {
    display: flex;
    align-items: center;
  }

  .room-item {
    height: 54px;
    font-size: 16px;
    margin-left: 20px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .room-text {
    cursor: pointer;
    white-space: nowrap;
    :hover {
      color: $sdf-blue;
    }
  }

  .first-item {
    margin-left: 0px;
  }

  .selected {
    padding-top: 4px;
    color: $sdf-blue;
    border-bottom: solid 4px;
    font-weight: bold;
  }

  .room-inactive {
    color: $sdf-gray;
  }

  .category-separator {
    border-right: 1px solid;
    height: 30px;
  }

  .print-button-area {
    border-left: 1px solid;
    margin: 0 1.4rem;
    height: 30px;
    white-space: nowrap;
    cursor: pointer;
  }

  .printer-icon {
    margin: 0.4rem 0.6rem 0 1.8rem;
  }
}
</style>
